<template>
    <header>
        <div class="header-container wrapper d-flex flex-column-reverse flex-sm-row">
            <div class="header-left">
                <span class="title">La Misión es Simple,<br>hacer del diseño <br>algo cotidiano.</span>
            </div>
            <div class="header-right">
                <PolpoLogo></PolpoLogo>
            </div>
        </div>
    </header>
</template>

<script>
import PolpoLogo from '../assets/img/polpo-logo.svg'
export default {
  name: 'Header',
  components: {
    PolpoLogo
  }
}
</script>

<style lang="scss">
@import '../assets/scss/vars';
header{
    width: 100%;
    .header-container{
        padding: 30px 0;
        margin-top: 3rem;
        border-top: 1px solid $dark-gray;
        border-bottom: 1px solid $dark-gray;
        .header-left{
            flex: 1;
            .title{
                font-size: 46px;
                line-height: 110%;;
                font-weight:200;
            }
        }
        .header-right{
            flex: 1;
            svg {
                width: 200px;
                float: right;
                padding-top: 10px;
            }
        }
    }
}

@media screen and (max-width: 600px){
header{
    .header-container{
        margin-top: 0;
        .header-left{
            .title{
                font-size: 28px;
            }
        }
        .header-right{
            svg{
                float: left;
                width: 130px;
                padding-top: 0px;
                margin-bottom: 10px;
            }
        }
    }
}
}
</style>
